import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconPenRound = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.082 4.293a1 1 0 0 0-1.414 0l-10.5 10.5a1 1 0 0 0-.263.465l-.875 3.5a1 1 0 0 0 1.212 1.212l3.5-.875a.999.999 0 0 0 .465-.263l10.5-10.5a1 1 0 0 0 0-1.414l-2.625-2.625ZM6.374 17.626l.404-1.615 9.597-9.597 1.21 1.211-9.596 9.597-1.615.404ZM13 18a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconPenRound);
export default Memo;
